import { DefaultOptionType } from "antd/lib/select";

export interface MapSelectOptions<T> {
  sourceArray: T[] | undefined;
  labelAccessor: keyof T;
  valueAccessor: keyof T;
  keepFields?: (keyof T)[];
}

export const mapSelectOptions = <T extends object, R extends object = never>({
  sourceArray,
  labelAccessor,
  valueAccessor,
  keepFields,
}: MapSelectOptions<T>): (DefaultOptionType & R)[] => {
  if (!Array.isArray(sourceArray) || !sourceArray?.length) {
    return [];
  }

  return sourceArray?.map((entity) => ({
    label: entity?.[labelAccessor] as string,
    value: entity?.[valueAccessor] as string,
    ...(keepFields?.length
      ? keepFields.reduce((result, keepField) => {
          result[keepField] = entity[keepField as keyof T];
          return result;
        }, {} as Partial<T>)
      : {}),
  })) as (DefaultOptionType & R)[];
};
